import React from 'react';
import PropTypes from 'prop-types';

import StripeChargeModalProfilePhoto from 'dpl/components/StripeCharge/New/StripeChargeModal/StripeChargeModalProfilePhoto';
import { PAYMENT_REQUEST_CATEGORIES } from 'dpl/shared/constants/breeder_app';
import { isMobileUA } from 'dpl/shared/utils';

import StripeChargeModalPuppyCard from './StripeChargeModalPuppyCard';
import StripeChargeModalHeaderLogOut from './StripeChargeModalHeaderLogOut';

const isMobile = isMobileUA();

export default function StripeChargeModalHeader({
  breederProfile,
  subtotalInDollars,
  dog,
  excludePuppyCard,
  paymentCategory
}) {
  return (
    <div className="StripeChargeModalHeader">
      <StripeChargeModalProfilePhoto
        photoUrl={breederProfile.profile_photo_url}
      />
      <div className="pt17 pb7 ph20-md ph6 tc b--light-gray relative">
        <p className="title mb2"> {breederProfile.name}</p>
        {isMobile && <StripeChargeModalHeaderLogOut />}
      </div>
      {!excludePuppyCard && (
        <StripeChargeModalPuppyCard
          dog={dog}
          amountInDollars={subtotalInDollars}
          paymentCategory={paymentCategory}
          breederProfile={breederProfile}
        />
      )}
    </div>
  );
}

StripeChargeModalHeader.propTypes = {
  breederProfile: PropTypes.shape({
    profile_photo_url: PropTypes.string,
    name: PropTypes.string,
    pay_url: PropTypes.string
  }).isRequired,
  subtotalInDollars: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  excludePuppyCard: PropTypes.bool,
  dog: PropTypes.shape({
    name: PropTypes.string.isRequired,
    profile_photo_url: PropTypes.string,
    breed: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  paymentCategory: PropTypes.oneOf(Object.values(PAYMENT_REQUEST_CATEGORIES))
};

StripeChargeModalHeader.defaultProps = {
  dog: null,
  subtotalInDollars: null,
  excludePuppyCard: false,
  paymentCategory: null
};
